/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { slackDirectoryConnectionsListPersonAccounts } from "../funcs/slackDirectoryConnectionsListPersonAccounts.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListPersonAccountsResponseBody } from "../models/components/listpersonaccountsresponsebody.js";
import {
  ListSlackPersonAccountsRequest,
  ListSlackPersonAccountsSecurity,
} from "../models/operations/listslackpersonaccounts.js";
import { unwrapAsync } from "../types/fp.js";
export type SlackPersonAccountsQueryData = ListPersonAccountsResponseBody;

export function prefetchSlackPersonAccounts(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListSlackPersonAccountsRequest,
  security?: ListSlackPersonAccountsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildSlackPersonAccountsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildSlackPersonAccountsQuery(
  client$: GramCore,
  request: ListSlackPersonAccountsRequest,
  security?: ListSlackPersonAccountsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<SlackPersonAccountsQueryData>;
} {
  return {
    queryKey: queryKeySlackPersonAccounts({
      userId: request.userId,
      cursor: request.cursor,
      gramSession: request.gramSession,
    }),
    queryFn: async function slackPersonAccountsQueryFn(
      ctx,
    ): Promise<SlackPersonAccountsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(slackDirectoryConnectionsListPersonAccounts(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeySlackPersonAccounts(
  parameters: {
    userId: string;
    cursor?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "slackDirectoryConnections",
    "listPersonAccounts",
    parameters,
  ];
}
